"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ListItem = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _objectDestructuringEmpty(obj) { if (obj == null) throw new TypeError("Cannot destructure " + obj); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var ListItem = exports.ListItem = function ListItem(_ref) {
  var props = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  var className = "list-item";
  if (props.activeValue && props.activeValue.toString() === props.value.toString() && props.activeValue.toString() !== 'More') {
    className += " active-list-item";
  }
  return /*#__PURE__*/_react["default"].createElement("li", {
    className: className,
    key: props.key,
    onClick: props.onClick,
    onKeyPress: props.onClick
  }, /*#__PURE__*/_react["default"].createElement("p", {
    className: "dropdown-text no-gutters",
    "data-value": props.value,
    tabIndex: 0
  }, props.text), /*#__PURE__*/_react["default"].createElement("div", {
    className: "dropdown-divider no-gutters"
  }));
};
//# sourceMappingURL=ListItem.js.map